import React, { Component } from "react";
import { connect } from "react-redux";
import Modal from "../common/Modal";
import { updateAdmin } from "../../actions/authActions";

export class EditUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: props.user.name
    };
  }
  handleCancelEditUser = () => {
    this.props.handleCancelEditUser();
  };
  handleSubmit = e => {
    e.preventDefault();
    const { name } = this.state;
    this.props.updateAdmin({ name }, this.props.user.id);
    this.setState({ name: "" });
    this.props.handleCancelEditUser();
  };
  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };
  render() {
    const { name } = this.state;
    return (
      <Modal
        id="editUser"
        key="editUser"
        open={true}
        size={"mini"}
        header="Edit User"
        onClose={this.handleCancelEditUser}
      >
        <div className="row">
          <div className="col-md-12">
            <form onSubmit={this.handleSubmit}>
              <div className="box-body">
                <div className="form-group">
                  <label htmlFor="exampleInputEmail1">Name</label>
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    name="name"
                    placeholder="Name"
                    value={name}
                    onChange={this.handleChange}
                    required
                  />
                </div>
              </div>
              <div className="box-footer" style={{ textAlign: "center" }}>
                <button type="submit" className="btn btn-primary">
                  Update
                </button>
              </div>
            </form>
          </div>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  errors: state.errors
});

export default connect(mapStateToProps, { updateAdmin })(EditUser);



// WEBPACK FOOTER //
// ./src/components/Admin/EditAdmin.js